import Vue from 'vue'
import VueMatchHeights from 'vue-match-heights'
Vue.use(VueMatchHeights, {
  disabled: [1024],
})
